import { HttpCode } from '@lemonade-hq/ts-helpers';
import { Client } from './client.esm.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function setupClientAuth(auth) {
    switch(auth.unauthorizedBehavior){
        case "login_via_redirect":
            setupUnauthorizedViaRedirectHandler(auth);
            break;
        case "callback":
            setupLoginViaCallback(auth);
            break;
    }
}
function setupUnauthorizedViaRedirectHandler(auth) {
    Client.getAxiosInstance().interceptors.response.use(function(response) {
        return response;
    }, function() {
        var _ref = _async_to_generator(function(error) {
            var _error_response, status;
            return _ts_generator(this, function(_state) {
                status = ((_error_response = error.response) !== null && _error_response !== void 0 ? _error_response : {
                    status: null
                }).status;
                if (status === HttpCode.Unauthorized) {
                    window.location.assign(auth.loginUrl);
                }
                throw error;
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}
function setupLoginViaCallback(auth) {
    var instance = Client.getAxiosInstance();
    var unauthorizedPendingRequests = [];
    instance.interceptors.response.use(function(response) {
        return response;
    }, function() {
        var _ref = _async_to_generator(function(error) {
            var _error_response, status;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        status = ((_error_response = error.response) !== null && _error_response !== void 0 ? _error_response : {
                            status: null
                        }).status;
                        if (!(status === HttpCode.Unauthorized)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                // save the request and its promise for later resolving
                                unauthorizedPendingRequests.push({
                                    config: error.config,
                                    resolve: resolve,
                                    reject: reject
                                });
                                if (unauthorizedPendingRequests.length === 1) {
                                    if (auth.unauthorizedCallback == null) {
                                        throw new Error("Missing unauthorizedCallback in auth config");
                                    }
                                    auth.unauthorizedCallback(function() {
                                        // once callback is resolved, retry each pending 401 request with its promise arguments
                                        unauthorizedPendingRequests.forEach(function(pendingRequest) {
                                            instance.request(pendingRequest.config).then(pendingRequest.resolve).catch(pendingRequest.reject);
                                        });
                                        unauthorizedPendingRequests = [];
                                    });
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        throw error;
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}

export { setupClientAuth };
